import { render, staticRenderFns } from "./TableBenefits.vue?vue&type=template&id=4357b870&"
import script from "./TableBenefits.vue?vue&type=script&lang=js&"
export * from "./TableBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports